import React from 'react';
import './Banner.css';

const Banner = () => {
    return (
        <div>
            <div className="banner-image">
          <div className="banner-text ">
            <h3 style={{fontSize:"4rem "}}>Amazing Tours And Funs <br />AdvenTures Tour Waiting For You </h3>
           
            
          </div>
        </div>
        </div>
    );
};

export default Banner;